/* Equaliv V2 · busca preditiva (Figma 9.1–9.3 desktop · 11.1–11.4 mobile em ecrã inteiro com barra "Cancelar")
   Liga-se aos formulários de busca existentes (header desktop, busca mobile, gaveta do menu e página de busca),
   busca /search/suggest com Section Rendering (sections/eq-predictive-search.liquid) e mostra o painel flutuante.
   Buscas recentes em localStorage ("eq:search:recent"). */
(() => {
  if (window.EQ_SEARCH) return;
  const me = document.currentScript;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SECTION = 'eq-predictive-search';
  const KEY = 'eq:search:recent';
  const FORMS = 'form[data-eq-search], [data-eq-msearch] form, form.eq-mdrawer__search, form[data-eq-sform]';
  const TYPES = 'product,article,page';
  const mqD = window.matchMedia('(min-width: 990px)');
  const esc = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* estilos */
  if (!document.querySelector('link[data-eq-search-css]')) {
    const href = (me && (me.dataset.css || (me.src && me.src.replace(/eq-search(\.min)?\.js/, 'eq-search.css')))) || '';
    if (href) {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.dataset.eqSearchCss = '';
      document.head.appendChild(l);
    }
  }

  /* ---------- buscas recentes ---------- */
  const recent = {
    get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; } },
    set(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 10))); } catch (_) {} },
    add(t) { t = (t || '').trim(); if (!t) return; this.set([t, ...this.get().filter((x) => x.toLowerCase() !== t.toLowerCase())]); },
    remove(t) { this.set(this.get().filter((x) => x !== t)); },
  };
  const searchUrl = (q) => `${root}search?q=${encodeURIComponent(q)}&type=${encodeURIComponent(TYPES)}&options%5Bprefix%5D=last`;
  const ICO_CLOCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  const ICO_X = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  /* ---------- painel ---------- */
  let weLocked = false, overlay = null, panel = null, body = null, mbar = null, minput = null, input = null, timer = 0, ctrl = null, lastQ = null, cart = null, idle = null;
  const cache = new Map();

  const build = () => {
    if (panel) return;
    overlay = document.createElement('div');
    overlay.className = 'eq-ps-overlay';
    overlay.addEventListener('click', () => close());
    panel = document.createElement('div');
    panel.className = 'eq eq-ps-panel';
    panel.id = 'EqPredictiveSearch';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Resultados da busca');
    const cancel = (window.EQ_SETTINGS && EQ_SETTINGS.searchCancel) || 'Cancelar';
    panel.innerHTML = `<div class="eq-ps-mbar"><form action="${root}search" method="get" role="search" class="eq-ps-mbar__form" data-eq-sform><input type="search" name="q" autocomplete="off" aria-label="Buscar" placeholder="Buscar produtos e receitas"><button type="submit" aria-label="Buscar"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg></button></form><button type="button" class="eq-ps-mbar__cancel" data-eq-ps-cancel>${esc(cancel)}</button></div><div class="eq-ps-body" data-eq-ps-body></div>`;
    body = panel.querySelector('[data-eq-ps-body]');
    mbar = panel.querySelector('.eq-ps-mbar');
    minput = mbar.querySelector('input');
    document.body.append(overlay, panel);
    panel.addEventListener('click', onPanelClick);
  };

  const place = () => {
    if (!panel || !input) return;
    const form = input.closest('form');
    if (!form) return;
    const r = form.getBoundingClientRect();
    const st = panel.style;
    if (mqD.matches) {
      const bar = form.closest('.eq-header__session') || form;
      const top = Math.round(r.bottom + 12);
      const width = Math.min(975, window.innerWidth - 48);
      const left = Math.max(24, Math.min(Math.round(r.left), window.innerWidth - width - 24));
      st.setProperty('--eq-ps-top', top + 'px');
      st.setProperty('--eq-ps-left', left + 'px');
      st.setProperty('--eq-ps-width', width + 'px');
      st.setProperty('--eq-ps-max', Math.max(320, window.innerHeight - top - 24) + 'px');
      overlay.style.setProperty('--eq-ps-top', Math.round(Math.max(bar.getBoundingClientRect().bottom, 0)) + 'px');
    } else {
      st.setProperty('--eq-ps-top', '0px');
      overlay.style.setProperty('--eq-ps-top', '0px');
    }
  };

  const isOpen = () => panel && panel.classList.contains('is-open');
  const open = () => {
    build();
    place();
    if (isOpen()) return;
    /* abre visível na hora (só opacidade/posição animam), para o campo do painel poder receber o foco já */
    panel.style.transition = 'opacity .18s, transform .18s, visibility 0s';
    panel.classList.add('is-open');
    overlay.classList.add('is-open');
    if (input) { input.setAttribute('aria-expanded', 'true'); const f = input.closest('form'); if (f) f.classList.add('eq-ps-active'); }
    if (!mqD.matches && window.EQ && EQ.lock && !document.documentElement.classList.contains('eq-lock')) { EQ.lock(true); weLocked = true; }
    if (!mqD.matches && input && input !== minput) {
      minput.value = input.value;
      const src = input;
      input = minput;
      prep(minput.closest('form'));
      /* o painel ainda pode estar em transição (visibility): tenta de novo até o campo receber o foco */
      const toPanel = (n) => {
        minput.focus({ preventScroll: true });
        if (document.activeElement !== minput && n > 0) { setTimeout(() => toPanel(n - 1), 60); return; }
        try { minput.setSelectionRange(minput.value.length, minput.value.length); } catch (_) {}
        if (document.activeElement === minput) src.blur();
      };
      setTimeout(() => toPanel(5), 30);
    }
    loadCart();
  };
  const close = () => {
    clearTimeout(timer);
    if (ctrl) ctrl.abort();
    if (!isOpen()) return;
    panel.style.transition = '';
    panel.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.querySelectorAll('.eq-ps-active').forEach((f) => f.classList.remove('eq-ps-active'));
    if (input) input.setAttribute('aria-expanded', 'false');
    if (weLocked && window.EQ && EQ.lock) EQ.lock(false);
    weLocked = false;
  };

  const extract = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const src = doc.querySelector('[data-eq-ps-src]');
    return src ? src.innerHTML : '';
  };

  const render = (html) => {
    if (!html) return;
    build();
    body.innerHTML = html;
    fillRecent();
    syncCart();
    open();
  };

  const getIdle = async () => {
    if (idle) return idle;
    const inline = [...document.querySelectorAll('[data-eq-ps-src]')].find((el) => !panel || !panel.contains(el));
    if (inline && inline.innerHTML.trim()) return (idle = inline.innerHTML);
    const html = await fetch(`${root}?section_id=${SECTION}`).then((r) => r.text());
    return (idle = extract(html));
  };

  const query = async (q) => {
    q = q.trim();
    lastQ = q;
    if (!q) {
      try { render(await getIdle()); } catch (_) {}
      return;
    }
    if (cache.has(q)) { render(cache.get(q)); return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    if (panel) panel.classList.add('is-loading');
    try {
      const u = `${root}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,query,collection,article,page&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=${SECTION}`;
      const html = extract(await fetch(u, { signal: ctrl.signal }).then((r) => r.text()));
      cache.set(q, html);
      if (q === lastQ) render(html);
    } catch (_) {
      /* abortado ou falhou: mantém o que está aberto */
    } finally {
      if (panel) panel.classList.remove('is-loading');
    }
  };

  const fillRecent = () => {
    const box = panel.querySelector('[data-eq-ps-recent]');
    if (!box) return;
    const list = recent.get().slice(0, Number(box.dataset.limit) || 3);
    const ul = box.querySelector('[data-eq-ps-recent-list]');
    box.hidden = list.length === 0;
    if (!ul) return;
    ul.innerHTML = list.map((t) => `<li class="eq-ps__recent"><a href="${esc(searchUrl(t))}" class="eq-ps__row" data-eq-ps-term="${esc(t)}">${ICO_CLOCK}<span>${esc(t)}</span></a><button type="button" class="eq-ps__x" data-eq-ps-forget="${esc(t)}" aria-label="Remover ${esc(t)} das buscas recentes">${ICO_X}</button></li>`).join('');
  };

  /* ---------- carrinho: sacola ↔ stepper ---------- */
  const loadCart = async () => {
    if (cart) { syncCart(); return; }
    try { cart = await fetch(`${root}cart.js`).then((r) => r.json()); syncCart(); } catch (_) {}
  };
  const lineOf = (vid) => (cart && cart.items ? cart.items.findIndex((i) => String(i.variant_id) === String(vid)) : -1);
  const syncCart = () => {
    if (!panel || !cart) return;
    panel.querySelectorAll('[data-eq-ps-item]').forEach((row) => {
      const add = row.querySelector('[data-eq-ps-add]');
      const qty = row.querySelector('[data-eq-ps-qty]');
      if (!add || !qty || add.dataset.handle) return;
      const i = lineOf(row.dataset.variantId);
      const inCart = i >= 0;
      add.hidden = inCart;
      qty.hidden = !inCart;
      if (inCart) qty.querySelector('[data-eq-ps-n]').textContent = cart.items[i].quantity;
    });
  };
  document.addEventListener('eq:cart:updated', (e) => { if (e.detail && e.detail.items) { cart = e.detail; syncCart(); } });

  async function onPanelClick(e) {
    if (e.target.closest('[data-eq-ps-cancel]')) { e.preventDefault(); close(); if (minput) minput.blur(); return; }
    const forget = e.target.closest('[data-eq-ps-forget]');
    if (forget) { e.preventDefault(); recent.remove(forget.dataset.eqPsForget); fillRecent(); if (input) input.focus(); return; }
    const term = e.target.closest('[data-eq-ps-term]');
    if (term) recent.add(term.dataset.eqPsTerm);
    const add = e.target.closest('[data-eq-ps-add]');
    if (add) {
      e.preventDefault();
      if (add.dataset.handle) { close(); if (window.EQ && EQ.quickAdd) EQ.quickAdd(add.dataset.handle); else location.href = `${root}products/${add.dataset.handle}`; return; }
      const row = add.closest('[data-eq-ps-item]');
      add.classList.add('is-loading');
      try {
        if (window.EQ && EQ.cart) await EQ.cart.add([{ id: Number(row.dataset.variantId), quantity: 1 }], { open: false });
        if (window.EQ && EQ.toast) EQ.toast('Adicionado à sacola');
      } catch (err) {
        if (window.EQ && EQ.toast) EQ.toast(err.message);
      } finally {
        add.classList.remove('is-loading');
      }
      return;
    }
    const step = e.target.closest('[data-eq-ps-step]');
    if (step) {
      e.preventDefault();
      const row = step.closest('[data-eq-ps-item]');
      const box = step.closest('[data-eq-ps-qty]');
      const i = lineOf(row.dataset.variantId);
      if (i < 0 || !(window.EQ && EQ.cart)) return;
      box.classList.add('is-loading');
      try { await EQ.cart.change(i + 1, Math.max(0, cart.items[i].quantity + Number(step.dataset.eqPsStep))); } catch (err) { if (EQ.toast) EQ.toast(err.message); } finally { box.classList.remove('is-loading'); }
    }
  }

  /* ---------- ligação aos formulários ---------- */
  const prep = (form) => {
    if (!form || form.dataset.eqPsReady) return;
    form.dataset.eqPsReady = '1';
    let t = form.querySelector('input[name="type"]');
    if (!t) { t = document.createElement('input'); t.type = 'hidden'; t.name = 'type'; form.prepend(t); }
    t.value = TYPES;
    if (!form.querySelector('input[name="options[prefix]"]')) {
      const p = document.createElement('input');
      p.type = 'hidden'; p.name = 'options[prefix]'; p.value = 'last';
      form.prepend(p);
    }
    const q = form.querySelector('input[name="q"]');
    if (q) {
      q.setAttribute('autocomplete', 'off');
      q.setAttribute('aria-controls', 'EqPredictiveSearch');
      q.setAttribute('aria-expanded', 'false');
    }
  };
  const target = (el) => (el && el.matches && el.matches('input[name="q"]') && el.closest(FORMS) ? el : null);
  const bindAll = () => document.querySelectorAll(FORMS).forEach(prep);

  document.addEventListener('focusin', (e) => {
    const el = target(e.target);
    if (!el) return;
    prep(el.closest('form'));
    input = el;
    query(el.value);
  });
  document.addEventListener('input', (e) => {
    const el = target(e.target);
    if (!el) return;
    input = el;
    clearTimeout(timer);
    timer = setTimeout(() => query(el.value), 200);
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest(FORMS);
    if (!f) return;
    prep(f);
    const q = f.querySelector('input[name="q"]');
    if (q && !q.value.trim()) { e.preventDefault(); q.focus(); return; }
    if (q) recent.add(q.value);
  });
  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); if (input) input.blur(); return; }
    if (e.key === 'ArrowDown' && target(e.target)) {
      const first = (body || panel).querySelector('a[href], button:not([hidden])');
      if (first) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', (e) => {
    /* clique em qualquer barra de busca (header, busca mobile, gaveta do menu, painel): não fecha o painel;
       fora do campo e dos botões (bordas e espaços da barra), leva o foco ao campo e abre a busca */
    const bar = e.target.closest && e.target.closest(FORMS);
    if (bar) {
      if (!e.target.closest('input, button, a')) { const q = bar.querySelector('input[name="q"]'); if (q) q.focus(); }
      return;
    }
    if (!isOpen()) return;
    if (panel.contains(e.target) || (input && input.closest('form') && input.closest('form').contains(e.target))) return;
    if (e.target.closest('.eq-ps-overlay')) return;
    close();
  });
  window.addEventListener('resize', () => { if (isOpen()) place(); });
  window.addEventListener('scroll', () => { if (isOpen() && mqD.matches) place(); }, { passive: true });
  document.addEventListener('shopify:section:load', bindAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll); else bindAll();

  window.EQ_SEARCH = { recent, open: (el) => { input = el; query(el.value || ''); }, close };
})();
